import api from "../../services/api";
export const FETCH_ADDBASKET_FULFILLED = "FETCH_ADDBASKET_FULFILLED";
export const FETCH_ADDBASKET_REJECTED = "FETCH_ADDBASKET_REJECTED";
export const FETCH_ADDBASKET_PENDING = "FETCH_ADDBASKET_PENDING";
export const RESET_ADDBASKET = "RESET_ADDBASKET";

export function addBasket(
  id,
  supplierUserId,
  qty,
  attributes,
  handle,
  resetCart = true,
  returnWithUserTagMeta
) {
  return (dispatch) => {
    dispatch({ type: FETCH_ADDBASKET_PENDING });
    api
      .post("/gate/cart/add", {
        id,
        supplierUserId,
        qty,
        attributes,
        handle,
        resetCart,
        returnWithUserTagMeta
      })
      .then((response) => {
        dispatch({
          type: FETCH_ADDBASKET_FULFILLED,
          payload: response.data
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ADDBASKET_REJECTED,
          payload: error
        });
      });
  };
}

export function resetAddBasket() {
  return (dispatch) => {
    dispatch({
      type: RESET_ADDBASKET
    });
  };
}
